import { Skeleton } from "@/components/ui/skeleton";

interface MarketplaceListingCardSkeletonProps {
  variant?: 'default' | 'compact';
}

const MarketplaceListingCardSkeleton = ({ variant = 'default' }: MarketplaceListingCardSkeletonProps) => {
  if (variant === 'compact') {
    return (
      <div className="bg-card border border-border rounded-xl p-3 w-full">
        <Skeleton className="w-full h-32 rounded-lg mb-3" />
        <Skeleton className="h-4 w-3/4 mb-2" />
        <Skeleton className="h-3 w-1/2 mb-2" />
        <Skeleton className="h-5 w-1/3" />
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden w-full">
      {/* Image skeleton */}
      <Skeleton className="w-full aspect-[4/3]" />
      
      {/* Content */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <Skeleton className="h-5 w-4/5" />
        
        {/* Location */}
        <Skeleton className="h-4 w-1/2" />
        
        {/* Specs row */}
        <div className="flex gap-2">
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-6 w-20 rounded-full" />
          <Skeleton className="h-6 w-14 rounded-full" />
        </div>
        
        {/* Price */}
        <Skeleton className="h-6 w-1/3" />
        
        {/* Footer */}
        <div className="flex justify-between items-center pt-2 border-t border-border">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default MarketplaceListingCardSkeleton;
